import React from "react";

export const Gonjong = ({ className = "", flip = false }) => {
  const peaks = [];
  const step = 80;
  for (let x = 0; x < 1200; x += step) {
    peaks.push(
      `L ${x + 8} 30 Q ${x + 20} 22 ${x + 32} 10 Q ${x + 40} 2 ${x + 48} 10 Q ${x + 60} 22 ${x + 72} 30 L ${x + step} 48`
    );
  }
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 1200 48"
      preserveAspectRatio="none"
      className={`block h-8 w-full sm:h-12 ${flip ? "rotate-180" : ""} ${className}`}
    >
      <path d={`M 0 48 L 0 40 ${peaks.join(" ")} Z`} fill="currentColor" />
    </svg>
  );
};

export const Stamp = ({ className = "" }) => (
  <div
    data-testid="brand-stamp"
    aria-hidden="true"
    className={`flex h-24 w-24 -rotate-6 items-center justify-center rounded-full border-2 border-dashed border-kunyit text-center font-display text-[11px] font-bold leading-tight tracking-wide text-kunyit sm:h-28 sm:w-28 sm:text-xs ${className}`}
  >
    #YoSabana
    <br />
    Lamak
  </div>
);
